import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpContext } from '@angular/common/http';

import { CredentialsDto } from './dto';
import { Login, Credentials } from './models';
import { credentialsModelFromDto } from './mappers';
import { ResetPassword, VerificationCodeResponse } from './models/login';

import { ALLOW_REFRESH, getApiEndpoint } from '@/app/core/http';
import { ApiResponse, mapDataNonNull, ApiResponseNonNull } from '@/app/shared/http';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  private readonly http = inject(HttpClient);

  login(payload: Login): Observable<ApiResponseNonNull<Credentials>> {
    return this.http
      .post<ApiResponse<CredentialsDto>>(getApiEndpoint('auth.login'), payload, {
        context: new HttpContext().set(ALLOW_REFRESH, false),
      })
      .pipe(mapDataNonNull(credentialsModelFromDto));
  }

  refreshToken(): Observable<ApiResponseNonNull<Credentials>> {
    return this.http
      .post<ApiResponse<CredentialsDto>>(getApiEndpoint('auth.refresh'), null, {
        context: new HttpContext().set(ALLOW_REFRESH, false),
      })
      .pipe(mapDataNonNull(credentialsModelFromDto));
  }

  logout(): Observable<void> {
    return this.http.delete<void>(getApiEndpoint('auth.logout'), {
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }

  forgotPassword(email: string): Observable<string> {
    return this.http.post<string>(
      getApiEndpoint('auth.forgot-password'),
      { email },
      {
        context: new HttpContext().set(ALLOW_REFRESH, false),
      },
    );
  }

  resetPassword(data: ResetPassword): Observable<string> {
    return this.http.post<string>(getApiEndpoint('auth.reset-password'), data, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }

  checkVerificationCode(data: ResetPassword): Observable<VerificationCodeResponse> {
    const params = new HttpParams().set('code', data.code).set('email', data.email);
    return this.http.get<VerificationCodeResponse>(getApiEndpoint('auth.forgot-password'), {
      params,
      context: new HttpContext().set(ALLOW_REFRESH, false),
    });
  }
}
